import { IPagination } from "@inceptionbg/ui-components";
import { axiosInstance } from "../App";
import { INotification, INotificationFilters } from "../types/INotification";

export const getNotifications = (
  farmUuid: string,
  pagination: IPagination,
  filters?: INotificationFilters
) =>
  axiosInstance
    .get("/notifications", {
      params: {
        farmUuid,
        ...pagination,
        ...(filters || {}),
      },
    })
    .then(({ data }) => ({
      notifications: data.notifications as INotification[],
      totalRows: data.totalRows as number,
    }));
